import React from 'react';
import { MailIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export const HomeNewsletter = () => {
  return <section className="my-12 bg-slate-50 p-6 sm:p-8 rounded-lg border border-slate-200" data-id="element-2578">
      <div className="flex items-center mb-4" data-id="element-2579">
        <MailIcon className="h-5 w-5 text-slate-700 mr-2" data-id="element-2580" />
        <h2 className="text-xl font-serif font-bold text-slate-900" data-id="element-2581">
          Join 143,000+ Women Receiving Our Research Updates
        </h2>
      </div>
      <p className="text-base text-slate-700 leading-relaxed mb-6" data-id="element-2582">
        Get early access to our latest research findings, evidence-based
        protocols, and exclusive health resources. Our subscribers are the first
        to learn about new clinical trials and breakthrough discoveries.
      </p>
      <div className="bg-white p-4 rounded-lg border border-slate-200 mb-6" data-id="element-2583">
        <h3 className="text-slate-900 font-medium mb-3 flex items-center" data-id="element-2584">
          <CheckCircleIcon className="h-4 w-4 text-green-600 mr-2" data-id="element-2585" />
          Subscribe today and receive our free guide:
        </h3>
        <div className="flex flex-col sm:flex-row items-center bg-slate-50 p-3 rounded border border-slate-200" data-id="element-2586">
          <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" alt="Research guide" className="w-20 h-28 object-cover rounded mr-4 mb-3 sm:mb-0" data-id="element-2587" />
          <div data-id="element-2588">
            <h4 className="text-slate-900 font-medium text-lg" data-id="element-2589">
              "The Evidence-Based Woman's Health Guide: Separating Science from
              Marketing Hype"
            </h4>
            <p className="text-sm text-slate-600 mt-1" data-id="element-2590">
              A 47-page comprehensive guide to understanding clinical evidence
              and making informed health decisions. Includes evaluation
              checklists for supplements and treatments.
            </p>
          </div>
        </div>
      </div>
      <form className="space-y-4" data-id="element-2591">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2592">
          <div data-id="element-2593">
            <label htmlFor="firstName" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2594">
              First Name
            </label>
            <input type="text" id="firstName" className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-slate-500 focus:border-slate-500" placeholder="Your first name" data-id="element-2595" />
          </div>
          <div data-id="element-2596">
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2597">
              Email Address
            </label>
            <input type="email" id="email" className="w-full px-4 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-slate-500 focus:border-slate-500" placeholder="Your email address" data-id="element-2598" />
          </div>
        </div>
        <div className="flex items-start" data-id="element-2599">
          <input id="consent" type="checkbox" className="h-4 w-4 text-slate-600 focus:ring-slate-500 border-slate-300 rounded mt-1" data-id="element-2600" />
          <label htmlFor="consent" className="ml-2 block text-sm text-slate-600" data-id="element-2601">
            I consent to receive emails about women's health research and
            evidence-based solutions. I understand I can unsubscribe at any
            time.
          </label>
        </div>
        <button type="button" className="w-full sm:w-auto px-6 py-3 bg-slate-800 text-white font-medium rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 flex items-center justify-center" data-id="element-2602">
          Subscribe & Get Free Guide
          <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-2603" />
        </button>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between text-xs text-slate-500" data-id="element-2604">
          <p className="mb-2 sm:mb-0" data-id="element-2605">
            <span className="bg-green-50 text-green-700 px-2 py-0.5 rounded-full font-medium" data-id="element-2606">
              92% open rate
            </span>{' '}
            - Our subscribers value our research
          </p>
          <p className="flex items-center" data-id="element-2607">
            <CheckCircleIcon className="h-3 w-3 text-slate-400 mr-1" data-id="element-2608" />
            Your data is secure • No spam • Unsubscribe anytime
          </p>
        </div>
      </form>
    </section>;
};